module.exports = __webpack_public_path__ + "static/media/3_r_ctolik_79.53_73.43.a09b0d0d.png";